<template>
    <div class="resource-more">
        <bannerSearch :isShowAi='false' :isNewPage="true"></bannerSearch>
        <div class="tit tit-gray">特色资源 <div class="tit-bottom"></div></div>
        <ul class="resource-list">
            <li class="list" v-for="(item,index) in resourceList" :key="index">
                <div class="list-icon">
                    <img width="100%" :src="item.imgUrl" alt="">
                </div>
                <div class="list-info" @click="toPage(item)">
                    <div class="info-tit">{{item.name}}</div>
                    <div class="info-txt">{{item.introduce}}</div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import bannerSearch from '../comps/banner_search.vue'
import {resourceMoreListInfo} from '../../io/api.js'
export default {
    components: {
        bannerSearch,
    },
    data() {
        return {
            resourceList:[]
        }
    },
    watch: {},
    mounted() {
        this.getList();
    },
    methods: {
        getList(){
            resourceMoreListInfo().then(res=>{
                let {code,data,msg} = res.data;
                if(code==0){
                    this.resourceList=data.list||[];
                }else{
                    this,this.$message.error(msg||'请求失败～')
                }
            })
        },
        toPage(item){
            let url= this.$router.resolve({
                path:'resourceList',
                query:{
                   changeflag:6,
                   word:item.name,
                   link:item.link
                },
            })  
            this.$windowOpen({ url:url.href,isLogin:true} )
        },
    }
}
</script>
<style lang='less' scoped>
.resource-more{
    .tit{
        font-size: 32px;
        padding:0 20px;
        font-weight: bold;
        width: 168px;
        margin: 40px auto 60px;
        position: relative;
        .tit-bottom{
            width: 100%;
            position: absolute;
            bottom:0;
            left: 0;
            height: 22px;
        } 
        &.tit-gray{
            color: #333;
            .tit-bottom{
                background: url('../../assets/images/home/gray-bg.png') no-repeat left bottom;
                background-size: cover;
            }
        }
        
    }
    .resource-list{
        display: flex;
        flex-wrap: wrap;
        width: 1200px;
        margin: 0 auto 40px;
        .list{
            display: flex;
            justify-content: space-between;
            width: 580px;
            height: 140px; 
            background: #FCFCFC;
            border: 1px solid #E9ECEF;
            border-radius: 14px;
            padding:26px 40px;
            margin: 10px;
            color: #999999;
            &:hover{
                background: #EAF1FF;
                border: 1px solid #A0BDFF;
                box-shadow: 0px 2px 4px 0px rgba(22,93,255,0.1);
                color: #386DE8;
                .list-info .info-tit{
                    color: #386DE8;
                    font-weight: bold;
                }
                // .list-icon{
                //     width: 86px;
                //     height: 86px;
                //     border-radius: 50%;
                //     border:1px solid #386DE8;
                // }
            } 
            .list-icon{
                width: 86px;
                height: 86px;
                // border:1px solid red;
            }
            .list-info{
                width: 382px;
                cursor: pointer;
                .info-tit{
                    cursor: pointer;
                    font-size: 20px; 
                    color: #333333;
                    padding-bottom: 10px;
                }
                .info-txt{
                    font-size: 14px; 
                    line-height: 24px; 
                }
            }
        }
    }
}
</style>